import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ChatConversation from './components/ChatConversation';
import { NewDemo } from './components/new';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/new" element={<NewDemo />} />
        <Route path="/*" element={<ChatConversation />} />
      </Routes>
    </Router>
  );
}

export default App;
